"use client";

import React, { useEffect, useRef, useState } from "react";
import { Factory, Zap, Building2, HardHat, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
const businessAreas = [{
  title: "Telecom Networks",
  description: "Strategic partner to China Mobile, Telecom, and Unicom, providing high-precision G652D and G657A fibers for nationwide connectivity.",
  icon: Zap,
  link: "/SolutionsPage"
}, {
  title: "AI & Tech Giants",
  description: "Supporting Huawei, ByteDance, and ZTE with advanced data center infrastructure and high-bandwidth optical interconnect solutions.",
  icon: Building2,
  link: "/SolutionsPage"
}, {
  title: "Power & Energy",
  description: "Trusted by State Grid and China Southern Power Grid for robust communication systems in critical utility infrastructure.",
  icon: Factory,
  link: "/SolutionsPage"
}, {
  title: "Digital Innovation",
  description: "Collaborating with Alibaba and Tencent to pioneer next-generation FPV systems and intelligent data transmission technologies.",
  icon: HardHat,
  link: "/SolutionsPage"
}];
const partners = [{
  name: "中国移动"
}, {
  name: "电信"
}, {
  name: "联通"
}, {
  name: "华为"
}, {
  name: "中兴"
}, {
  name: "字节"
}, {
  name: "阿里"
}, {
  name: "腾讯"
}, {
  name: "国家电网"
}, {
  name: "南方电网"
}];
export default function CoreBusinessAreas() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return;
}